module.exports = __webpack_public_path__ + "assets/img/report_l4.75f6e1fb.png";